// import { Memoize } from "typescript-memoize";
import memoize from "fast-memoize";

import { iItemInfo, tStoreRecord } from "../../interfaces/chrInterfaces";
import { tAvailableFTokens, tAvailableUTokens, tDiscountPercent } from "../../interfaces/interfaces";
import { availableFTokens, availableUTokens, discountPercents, fTokens, itemIds, uTokens } from "../../settings";
import { store } from "../../store/store";
import { getAllAssetsQuery, getAssetBallanceQuery } from "./queries";

// type tCreateStoreRecordArg<T> = {value: T} | {func: ((ft: tAvailableFTokens, ut: tAvailableUTokens, perc: tDiscountPercent) => T)};

// export const createStoreRecord = <T>(arg: tCreateStoreRecordArg<T>): tStoreRecord<T> => {
export const createStoreRecord = <T>(value?: T, func?: (ft: tAvailableFTokens, ut: tAvailableUTokens, perc: tDiscountPercent) => T): tStoreRecord<T> => {
	return Object.fromEntries(
		availableFTokens.map(ft => [ft, Object.fromEntries(
			availableUTokens.map(ut => [ut, Object.fromEntries(
				discountPercents.map(perc => [perc, func? func(ft, ut, perc) : value])
			)])
		)])
	) as tStoreRecord<T>;
};

export const getItemInfoByAddress = memoize((address: string | Buffer): iItemInfo => {
	const formattedAddress = typeof address === 'string'? address : address.toString('hex');
	for (const fToken of availableFTokens) {
		for (const uToken of availableUTokens){
			for (const percent of discountPercents){
				if (itemIds[fToken][uToken][percent] === formattedAddress) return {
					fToken,
					uToken,
					percent
				}
			}
		}
	}
	throw new Error('');
});

export const getTokenBalance = async (type: 'funding' | 'underline', token?: tAvailableFTokens | tAvailableUTokens) => {
	const {currentFToken, currentUToken} = store.getState().app;
	const foundToken = token? token in availableFTokens ? fTokens[token as tAvailableFTokens] : token in availableUTokens ? uTokens[token as tAvailableUTokens] : undefined : undefined;
	return getAssetBallanceQuery((foundToken || (type === 'funding'? fTokens[currentFToken] : uTokens[currentUToken])).id);
}

/* export const getTokenIcon = Memoize(async (urlAddress: string) => {
	const response = await fetch(urlAddress);
	const res = await response.json();
	console.log('res: ', res, '\ntype: ', typeof res);
// 	try {
// 	  return (
// 		import.meta.env.VITE_CHROMIA_BLOCKCHAIN_IMG_BACKADDR +
// 		/info/get_token_icon?token=${token}
// 	  )
// 	} catch {
// 	  return ''
// 	}
//   }
}) */

export const getTokenIconUrl = memoize(async (token: tAvailableFTokens | tAvailableUTokens): Promise<string | undefined> => {
	return (await getAllAssetsQuery()).find(asset => asset.id === {...fTokens, ...uTokens}[token].id)?.icon_url;
});

/* type tGetTokenCurrencyByAddressProps = {
	(type: 'funding', address: string): tAvailableFTokens,
	(type: 'underlying', address: string): tAvailableUTokens,
}
export const getTokenCurrencyByAddress: tGetTokenCurrencyByAddressProps = memoize((type: 'funding' | 'underlying', address: string) => {
	if (type === 'funding') {
		for (const token in fTokens){
			if (fTokens[token as tAvailableFTokens].id === address) return token as tAvailableFTokens;
		}
	}
	if (type === 'underlying') {
		for (const token in uTokens){
			if (uTokens[token as tAvailableUTokens].id === address) return token as tAvailableUTokens;
		}
	}
	throw new Error('');
}); */

export const getTokenCurrencyByAddress = memoize(getTokenCurrencyByAddressBeforeMemo);

function getTokenCurrencyByAddressBeforeMemo(type: 'funding', address: string): tAvailableFTokens;
function getTokenCurrencyByAddressBeforeMemo(type: 'underlying', address: string): tAvailableUTokens;
function getTokenCurrencyByAddressBeforeMemo(type: 'funding' | 'underlying', address: string) {
	if (type === 'funding') {
		for (const token in fTokens){
			if (fTokens[token as tAvailableFTokens].id === address) return token as tAvailableFTokens;
		}
	}
	if (type === 'underlying') {
		for (const token in uTokens){
			if (uTokens[token as tAvailableUTokens].id === address) return token as tAvailableUTokens;
		}
	}
	throw new Error('');
};